import { useEffect, useState } from 'react';
export const useAwaitedState = promise => {
  const [state, setState] = useState({
    state: 'pending'
  });
  useEffect(() => {
    let canceled = false;
    setState({
      state: 'pending'
    });
    promise.then(value => {
      if (!canceled) {
        setState({
          state: 'fulfilled',
          value
        });
      }
    }).catch(reason => {
      if (!canceled) {
        setState({
          state: 'rejected',
          reason
        });
      }
    });
    return () => {
      canceled = true;
    };
  }, [promise]);
  return state;
};